import React, { Fragment } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import NProgress from 'nprogress';
import { Helmet } from 'react-helmet';
// import Loader from 'components/cleanui/layout/Loader'
import PublicLayout from './Public';
import AuthLayout from './Auth';
import MainLayout from './Main';
import PolicyLayout from './Policy';
import DataDeletionLayout from './DataDeletion';
import AboutLayout from './About';

const Layouts = {
  public: PublicLayout,
  auth: AuthLayout,
  main: MainLayout,
  policy: PolicyLayout,
  camp: PublicLayout,
  dataDeletion: DataDeletionLayout,
  about: AboutLayout,
};

const mapStateToProps = ({ user }) => ({ user });
// let previousPath = '';

const Layout = ({ user, children, location: { pathname } }) => {
  // Layout Rendering
  const getLayout = () => {
    if (pathname === '/') {
      return 'public';
    }

    if (pathname === '/privacy-policy' || pathname === '/terms') {
      return 'policy';
    }

    if (pathname === '/about-us') {
      return 'about';
    }

    if (pathname === '/facebookDataDeletion') {
      return 'dataDeletion';
    }

    if (/^\/camp(?=\/|$)/i.test(pathname)) {
      return 'camp';
    }

    if (/^\/auth(?=\/|$)/i.test(pathname)) {
      return 'auth';
    }

    return 'main';
  };

  const Container = Layouts[getLayout()];
  const isUserAuthorized = user.authorized;
  const isUserLoading = user.loading;
  const isAuthLayout = getLayout() === 'auth';
  const isPublicLayout = getLayout() === 'public';
  const isMainLayout = getLayout() === 'main';

  const BootstrappedLayout = () => {
    // show loader when user in check authorization process, not authorized yet and not on login pages
    if (isUserLoading && !isUserAuthorized && !isAuthLayout) {
      return null;
    }
    // redirect to login page if current is not login page and user not authorized
    if ((isPublicLayout || isMainLayout) && !isUserAuthorized) {
      return <Redirect to='/auth/login' />;
    }
    // in other case render previously set layout
    return <Container>{children}</Container>;
  };

  return (
    <Fragment>
      <Helmet titleTemplate='Patos - %s' title='Admin' />
      {BootstrappedLayout()}
    </Fragment>
  );
};

export default withRouter(connect(mapStateToProps)(Layout));
